<script lang="ts" setup>
import MobileModal from '~/components/ui/modals/MobileModal.vue'
import useCatalogStore from '~/shared/store/modules/catalog';
import AppButton from "~/components/ui/buttons/AppButton.vue";
import type { TCatalogSorting } from '~/shared/interfaces/catalog';

const catalogStore = useCatalogStore();
const localSortType = ref(catalogStore.selectedFilters.sorting)

function setSortType(sortType: TCatalogSorting) {
  localSortType.value = sortType;
}

function closeSortModal() {
  catalogStore.setCatalogSorting(localSortType.value)
  catalogStore.setSortingModalStatus(false)
}

</script>

<template>
  <MobileModal
    :modal-is-open="catalogStore.showSortingModal"
    @close-modal="catalogStore.setSortingModalStatus(false)"
    :hide-close="false"
  >
    <div class="sort-modal">
      <div class="sort-modal__title">Сортировка</div>
      <div class="sort-modal__container">
        <div
          v-for="(sortName, sortType) in catalogStore.sortingList"
          :key="`mobile-sort_${sortType}`"
          class="sort-modal__item"
          :class="sortType === localSortType && 'sort-modal__item_active'"
          @click="setSortType(sortType)"
        >
         {{ sortName }}
        </div>
      </div>
      <AppButton
        class="sort-modal__button"
        @click="closeSortModal"
        text="Применить"
      />
    </div>
  </MobileModal>
</template>

<style lang="scss" scoped>
.sort-modal {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__title {
    @include font(20px, 24px, 600);
  }

  &__container {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &__button {
    width: 100%;
    margin-top: 8px;
  }

  &__item {
    @include font(16px, 20px);
    border-radius: 8px;
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;

    &:before {
      content: '';
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid $control-border_grey;
    }

    &_active {
      &:before {
        border: 6px solid $control-bg_primary;
      }
    }
  }
}
</style>
